import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({ 
  header: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    paddingLeft: 17,
    paddingRight: 17,
    paddingTop: 11,
    paddingBottom: 10,
    marginRight: 7,
    marginTop: 8,
    backgroundColor: '#D4BFF9'
  },
  col1: {
    width: '100%', 
    flexDirection: 'column', 
    display: 'flex'
  },
  headerTitle: {
    fontSize: 14,
    fontWeight: 700, 
    wordBreak: 'break-word'
  }  
});